var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_832_4250)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114 146C119.523 146 124 141.523 124 136C124 130.477 119.523 126 114 126C108.477 126 104 130.477 104 136C104 141.523 108.477 146 114 146ZM114 154C123.941 154 132 145.941 132 136C132 126.059 123.941 118 114 118C104.059 118 96 126.059 96 136C96 145.941 104.059 154 114 154Z",
    fill: "#172B50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 5C17 2.79086 18.7909 1 21 1C34.0728 1 42.8025 7.27659 48.1408 14.3378C53.3135 21.18 55.5 29.0092 55.5 33C55.5 35.2091 53.7091 37 51.5 37C49.2909 37 47.5 35.2091 47.5 33C47.5 30.9908 46.0365 24.82 41.7592 19.1622C38.2164 14.476 32.8855 10.3209 25 9.2607V108C25 110.209 23.2091 112 21 112H1.5C-0.709139 112 -2.5 110.209 -2.5 108C-2.5 105.791 -0.709139 104 1.5 104H17V5Z",
    fill: "#172B50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 136C43 133.791 44.7909 132 47 132H86C88.2091 132 90 133.791 90 136C90 138.209 88.2091 140 86 140H47C44.7909 140 43 138.209 43 136Z",
    fill: "#172B50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 146C24.5228 146 29 141.523 29 136C29 130.477 24.5228 126 19 126C13.4772 126 9 130.477 9 136C9 141.523 13.4772 146 19 146ZM19 154C28.9411 154 37 145.941 37 136C37 126.059 28.9411 118 19 118C9.05887 118 1 126.059 1 136C1 145.941 9.05887 154 19 154Z",
    fill: "#172B50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1716 13.6716C57.7337 12.1095 60.2663 12.1095 61.8284 13.6716L66.3284 18.1716C67.0786 18.9217 67.5 19.9391 67.5 21V37H100C101.907 37 103.548 38.3458 103.922 40.2155L111.385 77.5274L157.684 85.5589C159.6 85.8913 161 87.5546 161 89.5V136C161 138.209 159.209 140 157 140H140.5C138.291 140 136.5 138.209 136.5 136C136.5 133.791 138.291 132 140.5 132H153V92.8659L107.316 84.9411C105.688 84.6588 104.402 83.4046 104.078 81.7845L96.7208 45H63.5C61.2909 45 59.5 43.2091 59.5 41V22.6569L56.1716 19.3284C54.6095 17.7663 54.6095 15.2337 56.1716 13.6716Z",
    fill: "#172B50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.5 81.5L91.5 50.5H61V81.5H96.5ZM69 73.5H87.1063L84.6869 58.5H69V73.5Z",
    fill: "#172B50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_832_4250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 162,
    height: 162,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.6e820d0166e672c5f6fdc4f4602a4bd8.svg";
export { ForwardRef as ReactComponent };